import React, { useEffect, useState, useLayoutEffect } from "react";
import axios from "axios";
import "./Terms.css";
import SubNav from "../../Layout/SubNav";
import rightImg from "../../Assets/undraw_contract_uy56.png";
import TermsDetail from "./TermsDetail";
import Footer from "../../Layout/Footer";
import Loader from "../../Components/Loader";

const TermAndCond = () => {
  const [data, setData] = useState();
  useEffect(async () => {
    const terms = await axios.get("https://staging-cms-main.ipurvey.com/terms");
    const layout = await axios.get(
      "https://staging-cms-main.ipurvey.com/layout"
    );
    setData([terms.data, layout.data]);
  }, []);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (data) {
    return (
      <div className="terms_and_cond_container">
        <SubNav head="Terms of Service" />
        <div className="mobileView_terms_top_img">
          <img src={rightImg} alt="" />
        </div>
        <div className="terms_top_main">
          <p className="mt-3 pre">{data[0].content}</p>
        </div>
        <div className="terms_cond_main_div">
          <div className="terms_ques_content_main">
            <TermsDetail data={data[0]} />
          </div>
          <div className="terms_two_div select_lang_div">
            <div className="terms_two_img_box">
              <img src={rightImg} alt="..." />
            </div>
          </div>
        </div>
        <Footer data={data[1]} />
      </div>
    );
  } else return <Loader />;
};

export default TermAndCond;
